import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, UrlTree } from '@angular/router';
import { catchError, from, map, Observable, of } from 'rxjs';
import { DatabaseCacheService } from '../../data/cache/database-cache.service';
import { StoreAuthService } from '../auth/store-auth.service';

@Injectable()
export class SystemAdminGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private storeAuth: StoreAuthService,
    private common: DatabaseCacheService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.checkPermission(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.checkPermissionChild(route, state);
  }

  checkPermission(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) : Observable<boolean> {
 

    if (this.common.doesSystemAdminKeyExist()) {
      if (this.isHomeAccessible()) {
        return of(true);
      }
    }
    

    return from(this.common.setLoginUser()).pipe(
      map(data => {
        if(this.isHomeAccessible()){
          return true;
        }  

        // High security: return 404 for all admin errors (prevents route enumeration)
        this.router.navigate(['/not-found']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/not-found']);
        return of(false);
      })
    );
    
  }

  isHomeAccessible(){
    if(!this.common.doesSystemAdminKeyExist()){
      this.router.navigate(['/unauthorized']);
      return false;
    }

    let sysAdmin = this.common.getSystemAdmin();
      let distributorAgent = this.common.hasAnyDistributorAgentRole();
    if (sysAdmin == null && (!distributorAgent)){
      return false;
    }    

    return true;
  }

  checkPermissionChild(  
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) :boolean {

              // { path: '', redirectTo: 'home', pathMatch: 'full' },
              // { path: 'home', component: SectionGroupAdminHomeComponent },
              // { path: 'section-groups', component: SectionGroupListComponent },
              // { path: 'section-groups/:sectionGroupId', component: SectionGroupDetailsComponent },
              // { path: 'user-data-template', component: UserDataTemplateListComponent },
              // { path: 'new-section-group', component: StaffDetailsComponent },
              // { path: 'admins', component: SystemAdminListComponent },
              // { path: 'monthly-summaries/:year/:month', component: MonthlySummariesListComponent},
              // { path: 'not-found', component: NotFoundComponent},
              // { path: '**', redirectTo: '/en/system-admin/home', pathMatch: 'full' }

    let sysAdmin = this.common.getSystemAdmin();
    let distributorAgent = this.common.hasAnyDistributorAgentRole();
    if (sysAdmin == null && (!distributorAgent)){
      // High security: return 404 for all admin errors (prevents route enumeration)
      this.router.navigate(['/not-found']);
      return false;
    }

    // if (!this.isChildRoute){
    //   this.router.navigate(['/not-found']);
    //   return false;
    // }


    if (state.url.indexOf('user-data-template') > 0){
      if(this.common.hasParameterUpdate()){
        return true;
      }
      else{
        // High security: return 404 for all admin errors (prevents route enumeration)
        this.router.navigate(['/not-found']);
        return false;
      }
    }

    if (state.url.indexOf('admins') > 0){
      if(this.common.hasSystemAdminManagement()){
        return true;
      }
      else{
        // High security: return 404 for all admin errors (prevents route enumeration)
        this.router.navigate(['/not-found']);
        return false;
      }
    }

    if (state.url.indexOf('section-groups') > 0){
      return true; // AllSectionGroupsManagementを持っていなくても表示可能
    }

    if (state.url.indexOf('monthly-summaries') > 0){
      return true;
    }

    if (state.url.indexOf('create-section-group-and-section') > 0){
      return true;
    }

    
    if (state.url.indexOf('build-info') > 0){
      return true;
    }

    if (state.url.indexOf('distributors') > 0){
      return true; // AllSectionGroupsManagementを持っていなくても表示可能
    }

    // Allow 'home' route for system admin
    if (state.url.includes('/system-admin/home') || state.url.endsWith('/system-admin')) {
      return true;
    }

    // Allow legal pages
    if (state.url.indexOf('tou') > 0 || state.url.indexOf('privacy') > 0 || state.url.indexOf('license') > 0) {
      return true;
    }

    // High security: return 404 for all admin errors (prevents route enumeration)
    this.router.navigate(['/not-found']);
    return false;
  }

  // private isChildRoute(url: string): boolean {
  //   const currentConfig = this.router.config.find(r => r.path === '');
  //   const childRoutes = currentConfig?.children || [];
  //   return childRoutes.some(child => url.includes(child.path));
  // }
}
